import Tag from './Tag';

export { Tag };
export default Tag;
